import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import NumberFormat from "react-number-format";

import { formatPrice, formatTitleInUrl, CarTransmission, stypes, renderNumberGreaterThan100 } from "../common/common";

import carPhotoDefault from "../../static/images/upload/car_1.png";

import { IcFavorite, IcInstant, IcStarRating, IcTotalTrip, IcAddrCar, IcIns, IcNonMortgageGreen } from "../common/svg";

const CarItemFeatures = (props) => {
	const { car, stype, city, appInit } = props;
	const isSD = stype === stypes.SD;
	const priceMode = appInit?.data?.priceMode;
	const hiddenFeeMode = priceMode === 2;

	return (
		<Link to={`/car/${isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`} className={`item item-car`}>
			<div className="item-box">
				<div className="img-car">
					<div className="fix-img">
						<img
							loading="lazy"
							src={car.photos ? car.photos[0].thumbUrl : carPhotoDefault}
							alt={`${
								isSD ? `Cho thuê xe tự lái ${city ? `${city}` : ""}` : `Cho thuê xe du lịch ${city ? `${city}` : ""}`
							} ${car.name}`}
						/>
					</div>
					{/* <div className="fav-item wrap-svg">
						<IcFavorite />
					</div> */}

					<span className="label-pos">
						{isSD ? (
							<>
								{car.instant > 0 && (
									<span className="rent">
										Đặt xe nhanh <IcInstant />
									</span>
								)}
								{car.nonMortgage > 0 && (
									<span className="rent">
										Miễn thế chấp <IcNonMortgageGreen />
									</span>
								)}
							</>
						) : (
							<>
								{car.wdShort && car.wdShort.instant === 1 && (
									<span className="rent">
										Đặt xe nhanh <IcInstant />
									</span>
								)}
							</>
						)}
					</span>

					{/* {car.ownerHostFiveStar > 0 && <div className="no-owner has-five-star"></div>} */}

					{isSD
						? car.totalDiscountPercent > 0 && <span className="discount">Giảm {car.totalDiscountPercent}%</span>
						: car.wdShort &&
						  car.wdShort.totalDiscountPercent > 0 && (
								<span className="discount">Giảm {car.wdShort.totalDiscountPercent}%</span>
						  )}
				</div>

				<div className="desc-car">
					<div className="desc-tag">
						<span className={`tag-item ${car.optionsTransmission === 1 ? "transmission" : "delivery"}`}>
							{CarTransmission[car.optionsTransmission]}
						</span>
						{isSD ? (
							<>
								{car.deliveryEnable === 1 && (
									<span className="tag-item non-mortgage">
										{car.deliveryPrice === 0 ? "Miễn phí giao nhận" : "Giao xe tận nơi"}
									</span>
								)}
							</>
						) : null}
					</div>
					<div className="desc-name">
						<p>{car.name}</p>
						{/* {car.insSupport === 1 && (
							<div className="wrap-svg">
								<IcIns />
							</div>
						)} */}
					</div>

					<div className="desc-address-price">
						<div className="address">
							<div className="wrap-svg">
								<IcAddrCar />
							</div>
							<p>{car.locationAddrS}</p>
						</div>
					</div>

					<div className="line-page" />
					<div className="desc-info-price">
						<div className="info">
							{car.totalTrips > 0 ? (
								<>
									{car.rating.avg > 0 ? (
										<>
											<div className="wrap-svg">
												<IcStarRating />
											</div>
											<span className="info">{car.rating.avg.toFixed(1)}</span>
											<span className="dot">•</span>
										</>
									) : null}
									<div className="wrap-svg">
										<IcTotalTrip />
									</div>
									<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
								</>
							) : (
								<span className="info">Chưa có chuyến</span>
							)}
						</div>

						<div className="wrap-price">
							{isSD ? (
								hiddenFeeMode ? (
									<div className="price">
										{car.priceOriginWithFee !== car.priceWithFee && (
											<span className="price-origin">
												<NumberFormat
													value={formatPrice(car.priceOriginWithFee)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
											</span>
										)}
										<span className="price-special">
											<NumberFormat
												value={formatPrice(car.priceWithFee)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										</span>
										/&nbsp;ngày
									</div>
								) : (
									<div className="price">
										{car.priceOrigin !== car.price && (
											<span className="price-origin">
												<NumberFormat
													value={formatPrice(car.priceOrigin)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
											</span>
										)}
										<span className="price-special">
											<NumberFormat
												value={formatPrice(car.price)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										</span>
										/&nbsp;ngày
									</div>
								)
							) : hiddenFeeMode ? (
								<div className="price">
									{car.wdShort && car.wdShort.priceOriginWithFee !== car.wdShort.priceWithFee && (
										<span className="price-origin">
											<NumberFormat
												value={formatPrice(car.wdShort.priceOriginWithFee)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
											</span>
									)}
									<span className="price-special">
											<NumberFormat
												value={formatPrice(car.wdShort && car.wdShort.priceWithFee)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										&nbsp;</span>
									/&nbsp;chuyến
								</div>
							) : (
								<div className="price">
									{car.wdShort && car.wdShort.priceOrigin !== car.wdShort.price && (
										<span className="price-origin">
											<NumberFormat
												value={formatPrice(car.wdShort.priceOrigin)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
											</span>
									)}
									<span className="price-special">
											<NumberFormat
												value={formatPrice(car.wdShort && car.wdShort.price)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										&nbsp;</span>
									/&nbsp;chuyến
								</div>
							)}

							{isSD
								? car.priceTotal > 0 && (
										<div className="total-price">
											<p>
												Giá tổng 
												<NumberFormat
													value={formatPrice(car.priceTotal)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
									
											</p>
										</div>
								  )
								: car.wdShort &&
								  car.wdShort.finalPrice > 0 && (
										<div className="total-price">
											<p>
												Giá tổng 
												<NumberFormat
													value={formatPrice(car.wdShort.finalPrice)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
											
											</p>
										</div>
								  )}
						</div>
					</div>
				</div>
			</div>
		</Link>
	);
};

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(CarItemFeatures);
